<template>
	<div>
		<Accordion
			v-on:toggle="
				() => {
					this.accordionShow = !this.accordionShow
				}
			"
			v-bind:show="this.accordionShow"
			:title="guestName"
			:lightTheme="true"
			:largeSvg="true"
			:blueTheme="!hideCreate"
		>
			<div>
				<Guest_Form
					@hide-accordion="emptyCreate"
					:guestlid="guestlid"
					:edit="hideCreate"
				/>
			</div>
		</Accordion>
	</div>
</template>

<script>
import store from '../../vueX/store'
import Accordion from '../../components/molecules/Accordion.vue'
import Guest_Form from '../../components/organisms/forms/Guest_Form'

export default {
	name: 'ProfileGuestCard',
	store,
	components: {
		Accordion,
		Guest_Form
	},
	props: {
		guestName: {
			type: String,
			default: ''
		},
		guestlid: {
			type: Number,
			default: 0
		},
		guest: {
			type: Object,
			default: () => {}
		},
		hideCreate: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			accordionShow: false
		}
	},
	methods: {
		emptyCreate() {
			this.accordionShow = !this.accordionShow
		}
	},
	computed: {},
	created() {
		if (this.$route.params.id == this.guestlid) {
			this.accordionShow = true
		}
	}
}
</script>

<style scoped lang="scss">
.profile-overview-card {
	background: $colorWhite;
	padding: 60px 40px 40px 40px;
	position: relative;
	box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	text-align: center;
	&__icon {
		width: 100px;
		height: 100px;
		border-radius: 100px;
		background: $colorPrimary6;
		top: 0;
		position: absolute;
		left: 50%;
		transform: translate(-50%, -50%);
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
		display: flex;
		justify-content: center;
		svg {
			fill: $colorWhite;
			width: 80px;
		}
	}
	&__actions {
		display: flex;
		justify-content: space-around;
	}
	&__booking-item {
		background: $colorWhite;
		padding: 20px;
		margin: 10px 0;
		position: relative;
		box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
	}
	&__title {
		font-weight: 400;
		margin-bottom: 10px;
		margin-bottom: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	&__subtitle {
		color: #949eb1;
		font-size: 12px;
		letter-spacing: 0;
		line-height: 19px;
	}
}
</style>
